"use strict";

var _classCallCheck = require("/var/nobackup/jenkins/jobs/DDI Frontend/branches/release-2022-04.94hkrn/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/var/nobackup/jenkins/jobs/DDI Frontend/branches/release-2022-04.94hkrn/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/var/nobackup/jenkins/jobs/DDI Frontend/branches/release-2022-04.94hkrn/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _get = require("/var/nobackup/jenkins/jobs/DDI Frontend/branches/release-2022-04.94hkrn/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/get");

var _getPrototypeOf = require("/var/nobackup/jenkins/jobs/DDI Frontend/branches/release-2022-04.94hkrn/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/var/nobackup/jenkins/jobs/DDI Frontend/branches/release-2022-04.94hkrn/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _assertThisInitialized = require("/var/nobackup/jenkins/jobs/DDI Frontend/branches/release-2022-04.94hkrn/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/assertThisInitialized");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Region = void 0;

var RegionComponent_1 = require("./Component/RegionComponent");
/* import * as SNAPSVG_TYPE from "snapsvg";
declare var Snap: typeof SNAPSVG_TYPE; */


var Region = /*#__PURE__*/function (_RegionComponent_1$Re) {
  _inherits(Region, _RegionComponent_1$Re);

  /**
   * Creates new `Region` object.
   * @param paper - The `Snap.Paper` object to draw on.
   * @param paperRect - The parent bounding box for created component.
   * @param regionData - The `RegionData` object shared across components. Used also for initial setup.
   * @param callbacks - The external callbacks collection.
   * @param id - The region `id` used to identify regions in `RegionsManager`.
   * @param tagsDescriptor - The descriptor of region tags.
   * @param tagsUpdateOptions - The drawing options for tags.
   */
  function Region(paper) {
    var _this;

    var paperRect = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    var regionData = arguments.length > 2 ? arguments[2] : undefined;
    var callbacks = arguments.length > 3 ? arguments[3] : undefined;
    var id = arguments.length > 4 ? arguments[4] : undefined;
    var tagsDescriptor = arguments.length > 5 ? arguments[5] : undefined;
    var tagsUpdateOptions = arguments.length > 6 ? arguments[6] : undefined;

    _classCallCheck(this, Region);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Region).call(this, paper, paperRect, regionData, Object.assign({}, callbacks)));
    /**
     * The reference to the CSSStyleSheet object.
     */

    _this.styleSheet = null;
    _this.ID = id;
    _this.tags = tagsDescriptor;
    _this.regionID = _this.s8();
    _this.styleID = "region_".concat(_this.regionID, "_style");
    _this.styleSheet = _this.insertStyleSheet();
    _this.tagsUpdateOptions = tagsUpdateOptions;
    _this.UI = [];
    var onChange = _this.callbacks.onChange;

    _this.callbacks.onChange = function (region, regionData) {
      _this.regionData.initFrom(regionData);

      _this.redraw();

      for (var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
        args[_key - 2] = arguments[_key];
      }

      onChange.apply(void 0, [_assertThisInitialized(_assertThisInitialized(_this)), _this.regionData].concat(args));
    };

    return _this;
  }
  /**
   * Clear region styles.
   */


  _createClass(Region, [{
    key: "removeStyles",
    value: function removeStyles() {
      document.getElementById(this.styleID).remove();
    }
    /**
     * Updates region tags.
     * @param tags - The new tags descriptor object.
     * @param options - The tags drawing options.
     */

  }, {
    key: "updateTags",
    value: function updateTags(tags, options) {
      this.tags = tags;
      this.tagsUpdateOptions = options;
    }
  }, {
    key: "move",
    value: function move(arg1, arg2) {
      _get(_getPrototypeOf(Region.prototype), "move", this).call(this, arg1, arg2);

      this.redraw();
    }
    /**
     * Resizes the region to specified `width` and `height`.
     * @param width - The new region width.
     * @param height - The new region height.
     */

  }, {
    key: "resize",
    value: function resize(width, height) {
      _get(_getPrototypeOf(Region.prototype), "resize", this).call(this, width, height);

      this.redraw();
    }
    /**
     * Redraws the region component.
     */

  }, {
    key: "redraw",
    value: function redraw() {
      this.UI.forEach(function (element) {
        element.redraw();
      });
    }
    /**
     * Visually freeze the region.
     */

  }, {
    key: "freeze",
    value: function freeze() {
      _get(_getPrototypeOf(Region.prototype), "freeze", this).call(this);

      this.node.addClass("old");
      this.UI.forEach(function (element) {
        element.freeze();
      });
    }
    /**
     * Visually unfreeze the region.
     */

  }, {
    key: "unfreeze",
    value: function unfreeze() {
      _get(_getPrototypeOf(Region.prototype), "unfreeze", this).call(this);

      this.node.removeClass("old");
      this.UI.forEach(function (element) {
        element.unfreeze();
      });
    }
    /**
     * Internal helper function to generate random id.
     */

  }, {
    key: "s8",
    value: function s8() {
      return Math.floor((1 + Math.random()) * 0x100000000).toString(16).substring(1);
    }
    /**
     * Helper function to insert a new stylesheet into the document.
     */

  }, {
    key: "insertStyleSheet",
    value: function insertStyleSheet() {
      var style = document.createElement("style");
      style.setAttribute("id", this.styleID);
      document.head.appendChild(style);
      return style.sheet;
    }
  }]);

  return Region;
}(RegionComponent_1.RegionComponent);

exports.Region = Region;